export default __webpack_public_path__ + "static/gray-halftone-dots-95c674958c8ba1feac7b9db4940b4f38.svg";